export type Url = string;
export type Size = 'large' | 'normal' | 'small'; // TODO does it still needed?
export type Theme = 'light' | 'dark'; // TODO does it still needed?

export const ASPECT_RATIO_CONFIG = {
  landscape: '16:9',
  portrait: '2:3',
  square: '1:1',
  rectangle: '2:1',
  thinRectangle: '1920:750',
};
